<template>
  <div class="dialog" v-show="selectData.show">
    <div class="shade"></div>
    <div class="content">
      <div class="title">{{selectData.title}}</div>
      <div class="close" @click="()=>{selectData.show=false}">×</div>
      <div
        class="item"
        v-for="(item,index) in selectData.selectList"
        :key="index"
        @click="clickItem(item.value)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    selectData: {
      type: Object
    }
  },
  data: function() {
    return {
      value: {
        // 必须要使用value
        type: Number
      }
    };
  },
  computed: {},
  methods: {
    clickItem(val) {
      this.selectData.show = false;
      this.value = val;
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    }
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
.dialog {
  z-index: 9999;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .shade {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }

  .content {
    border-radius: 2px;
    position: relative;
    width: 80%;
    background: #fff;
    height: 122px;
    .title, .item {
      height: 40px;
      line-height: 40px;
      color: #333;
      text-align: center;
      font-size: 14px;
    }

    .item {
      border-top: 1px solid #999;
    }

    .close {
      position: absolute;
      right: 10px;
      top: 0px;
      font-size: 28px;
      width: 30px;
      text-align: center;
    }
  }
}
</style>